module.exports = __webpack_public_path__ + "img/20.4db77c45.svg";